module.exports = __webpack_public_path__ + "img/agricultural-reform-logo.d75f2cdc.jpeg";